import { Button } from '@cambridgeassessment/cambridge-ui/build/components/Button';
import { Box, Container } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import React, { memo } from 'react';
import { hot } from 'react-hot-loader/root';
import { Link } from 'react-router-dom';
import useOrgUsers from '../../../hooks/useOrgUsers';
import SearchField from '../../SearchField/SearchField';
import UsersTable from '../../UsersTable/UsersTable';
import routes from '../routes';
import { useStylesUsersPage } from '../styles';

const OrgUsers: React.FC = () => {
  const classes = useStylesUsersPage();

  const { searchQuery, updateSearchQuery } = useOrgUsers();

  return (
    <Container disableGutters maxWidth="xl">
      <Box
        display="flex"
        justifyContent={['unset', 'space-between']}
        flexDirection={['column', 'row']}
        alignItems={['flex-end', 'unset']}
      >
        <Box className={classes.searchField}>
          <SearchField
            searchQuery={searchQuery}
            placeholder="Search for a user"
            onSubmit={updateSearchQuery}
            onChange={updateSearchQuery}
          />
        </Box>
        <Box className={classes.button}>
          <Button
            component={Link}
            to={routes.AddUser.path}
            size="large"
            startIcon={<Add />}
            variant="contained"
            data-testid="addUsers"
            style={{
              textTransform: 'none',
            }}
          >
            Add user(s)
          </Button>
        </Box>
      </Box>
      <Box className={classes.table}>
        <UsersTable />
      </Box>
    </Container>
  );
};

export default hot(memo(OrgUsers));
